import { FC, ReactNode } from 'react'

import { useLocale } from 'languages/use-locale'
import { ProgramStyle, LeftColumn, RightColumn } from '../styled'
import { AboutContainer } from './styled'

type Props = {
  children?: ReactNode | ReactNode[]
  id: string
}

export const useInfoPage = (id: string) => {
  const { texts } = useLocale()
  return texts.about.find((p) => p.id === id)
}

export const InfoPageWrapper: FC<Props> = ({ id, children }) => {
  const pageContent = useInfoPage(id)

  if (!pageContent) {
    return null
  }

  return (
    <AboutContainer>
      <div>
        <ProgramStyle>
          <LeftColumn>
            <svg viewBox="0 0 16 9"></svg>
            <img src={pageContent.photo} alt={pageContent.title} />
          </LeftColumn>
          <RightColumn>
            <div>
              <h1>{pageContent.title}</h1>
              <h2>{pageContent.info}</h2>

              {children}

              {((pageContent?.description as string[]) ?? []).map((d, i) => (
                <p key={i} dangerouslySetInnerHTML={{ __html: d }}></p>
              ))}
            </div>
          </RightColumn>
        </ProgramStyle>
      </div>
    </AboutContainer>
  )
}
